import { useState } from 'react'
import styles from './Tooltip.module.scss'

interface TooltipProps {
  text: string
  position?: 'right' | 'top' | 'bottom'
  children: React.ReactNode
}

export function Tooltip({ text, position = 'right', children }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false)

  const positionClass = styles[`tooltip--${position}`]

  return (
    <div
      className={styles.wrapper}
      data-position={position}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <span role="tooltip" className={`${styles.tooltip} ${positionClass}`}>
          {text}
        </span>
      )}
    </div>
  )
}
